import React, { useCallback } from "react";

import { useHistory, useParams } from "react-router-dom";

import { ClientId, FartherAccountId } from "@fartherfinance/frontend/api/Types";

import useClientNameForId from "@src/multiCustodian/hooks/Advisor/useClientNameForId";
import { useFartherManagedClientAccount } from "@src/multiCustodian/hooks/Advisor/useFartherManagedClientAccount";

import ArchiveFartherManagedAccountModal from "./ArchiveFartherManagedAccountModal";

const ArchiveClientAccountModal = (): JSX.Element => {
  const { clientId, accountId } = useParams<{
    clientId: ClientId;
    accountId: FartherAccountId;
  }>();
  const history = useHistory();

  const { accountDisplayName } = useFartherManagedClientAccount(
    clientId,
    accountId
  );
  const currentClient = useClientNameForId(clientId);

  const handleClose = useCallback(
    () =>
      history.push({
        pathname: `/Advisor/Clients/${clientId}/Admin`,
        state: history.location.state,
      }),
    [history, clientId]
  );

  return (
    <ArchiveFartherManagedAccountModal
      accountDisplayName={accountDisplayName}
      clientDisplayName={currentClient?.fullName || "client"}
      onClose={handleClose}
      accountId={accountId}
      clientId={clientId}
    />
  );
};

export default ArchiveClientAccountModal;
